/* global axios */
import ApiClient from './ApiClient';

class TalkviaLeadCapturesAPI extends ApiClient {
  constructor() {
    super('talkvia_lead_captures', { accountScoped: true });
  }

  get() {
    return axios.get(this.url);
  }

  create(data) {
    return axios.post(this.url, { talkvia_lead_capture: data });
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, { talkvia_lead_capture: data });
  }

  publish(id) {
    return axios.post(`${this.url}/${id}/publish`);
  }

  disable(id) {
    return axios.post(`${this.url}/${id}/disable`);
  }

  duplicate(id) {
    return axios.post(`${this.url}/${id}/duplicate`);
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }
}

export default new TalkviaLeadCapturesAPI();
